import React from 'react';

// Define the type for a news item
export interface NewsItem {
  id: number;
  title: string;
  content: JSX.Element;
  date: string;
}

// Dummy data array of news items
export const newsData: NewsItem[] = [
  {
    id: 17,
    title: 'Big Upgrade, Same Price!',
    content: (
      <>
        Starting today, your program will be upgraded from the Pro plan to
        Business+ at no additional cost. Business+ includes a higher card limit
        of 5,000 cards, a dedicated account manager, and an upgrade to Spanish,
        French, and the Canadian market once rolled out. Questions? Please don't
        hesitate to{' '}
        <a
          target='_blank'
          href='/support'
          className='underline font-semibold pt-2 '
          rel='noreferrer'
        >
          Contact Us
        </a>
        , or schedule a 30min call with your{' '}
        <a
          target='_blank'
          href='https://calendar.app.google/rH2btYWsfdGb9DG18'
          className='underline font-semibold pt-2'
          rel='noreferrer'
        >
          Dedicated Account Manager
        </a>
        .
      </>
    ),
    date: 'September 1, 2025',
  },
  {
    id: 15,
    title: 'All-New Branding Controls for Your Program',
    content: (
      <>
        We're thrilled to announce the biggest and most exciting set of
        enhancements to the Savers App yet - built to give you more control and
        bring your brand to life within the app. Choose your own brand colors,
        set your own tagline, write a custom brand description, upload a
        promotional banner that highlights your identity, and much more.
        Navigate to Program Management {'>'} Branding to start customizing.
      </>
    ),
    date: 'July 30, 2025',
  },
  {
    id: 16,
    title: 'Enhanced Member Data Reporting',
    content: (
      <>
        The partner portal has just been upgraded to give you more insights into
        your members and program performance. Your list of members now includes
        their joining date, their number of enrolled cards, and date of
        enrollment. You can see the list of the most recent 100 members directly
        in the portal, or download the entire list in csv format. More features
        continue to be worked on and scheduled for release as we continue to
        enhance the portal based on your valuable feedback.
      </>
    ),
    date: 'June 12, 2025',
  },
  {
    id: 14,
    title: 'Limited-Time Promo: Get Rewarded for Every New Member',
    content: (
      <>
        Boost Your Program & Reach Your Goals Faster! Starting June 1, 2025,
        we’re excited to launch an exclusive limited-time promotion to
        supercharge your growth!
        <br />
        Earn <strong>$1 for every new member*</strong> who signs up to your
        program and enrolls one or more cards within 30 days – NO LIMITS!
        <br />
        <a
          target='_blank'
          href='/program-booster'
          className='underline font-semibold pt-2'
          rel='noreferrer'
        >
          Learn more
        </a>
      </>
    ),
    date: 'June 1, 2025',
  },
  {
    id: 7,
    title: 'Member Newsletters launched',
    content: (
      <>
        A new instructional Newsletter is now being sent to all new verified
        members to give them information about making the most of your program.
        The Newsletter is titled "Everything You Need to Know About Maximizing
        Cashback" and goes out to all new members within 24 hours of them
        verifying their account. This newsletter has also been sent to all
        existing members. The newsletter contains valuable information about the
        types of available offers, how the various redemptions work, along with
        a list of current offers across multiple categories.
      </>
    ),
    date: 'May 22, 2025',
  },
  {
    id: 8,
    title: 'Partner Portal Enhancements',
    content: (
      <>
        The partner portal has just been upgraded to provide you with much more
        detail, giving you more insights into your members and program
        performance. You can now see the list of the most recent 100 members
        that have joined your program, or download the entire list in csv
        format. Your Upcoming payouts have also been added to the dashboard
        along with explanations and breakdown of your earnings in the current
        month and to date. More features continue to be worked on and scheduled
        for release as we continue to enhance the portal based on your valuable
        feedback.
      </>
    ),
    date: 'May 19, 2025',
  },
  {
    id: 9,
    title: 'Member Payouts',
    content: (
      <>
        Your members have just been paid their Cashback for the month. Anyone
        that had a balance of $10 or more of 'Confirmed' Cashback, will have
        received the payout information request. At the moment, the automated
        reimbursement back to a member's preferred card is not fully functional.
        So, member Cashback payouts are being sent through a direct ACH deposit
        to their bank account.
      </>
    ),
    date: 'May 15, 2025',
  },
  {
    id: 10,
    title: 'Member Card Enrollment Reminders',
    content: (
      <>
        A new automated email has been enabled to remind new members to enroll
        their cards. Any new member that has not yet enrolled a card 1 week
        after signing up to your program will be sent an email reminder with the
        title "Maximize Your Cashback! Enroll Your Cards Today".
      </>
    ),
    date: 'May 5, 2025',
  },
  {
    id: 11,
    title: 'Member Payouts',
    content: (
      <>
        Your members have just been paid their Cashback for the month. Anyone
        that had a balance of $10 or more of 'Confirmed' Cashback, will have
        received the payout information request. At the moment, the automated
        reimbursement back to a member's preferred card is not fully functional.
        So, member Cashback payouts are being sent through a direct ACH deposit
        to their bank account.
      </>
    ),
    date: 'April 15, 2025',
  },
  {
    id: 12,
    title: 'App Update v4.2.2',
    content: (
      <>
        A new feature-packed update has just been released. One particular
        update that is important to be aware of is the hiding of earned Cashback
        amounts until they're confirmed. This enhancement has been introduced to
        improve your members' experience by only showing them their reward
        amounts once they've been confirmed by the reward merchant. With 'Click'
        offers, unlike 'Card-linked' offers, the Cashback rate is usually{' '}
        <strong>Up To X%</strong> and depends on the actual items that are
        purchased. The confirmation of the purchased items and their respective
        reward category can sometimes take a few weeks to be confirmed by the
        merchant. Before the final reward amount is confirmed, what a member
        used to see in the app was the <strong>potential</strong> value based on
        the highest Cashback rate (the <strong>Up-To</strong> rate). However,
        once the transaction gets confirmed by the merchant, the reward amount
        may be revised based on the eligibility of the items that were purchased
        as determined by the merchant. As such, this can lead to some confusion
        for members. So, to avoid this, we now block the reward amount until we
        have confirmation from the merchant that they will not be revising the
        amount any more.
      </>
    ),
    date: 'April 9, 2025',
  },
  {
    id: 13,
    title: 'Member Payouts',
    content: (
      <>
        Your members have just been paid their Cashback for the month. Anyone
        that had a balance of $10 or more of 'Confirmed' Cashback, will have
        received the payout information request. At the moment, the automated
        reimbursement back to a member's preferred card is not fully functional.
        So, member Cashback payouts are being sent through a direct ACH deposit
        to their bank account.
      </>
    ),
    date: 'March 15, 2025',
  },

  // 👇 الأخبار القديمة التي كانت موجودة سابقًا (من id:1 إلى id:6)
  {
    id: 1,
    title: 'App Enhancements',
    content: (
      <>
        The latest release of the app is packed with new features and fixes. One
        such enhancement is the clear distinction between “Card linked” offers
        and “Click” offers. Members will now see the relevant icon next to each
        listed merchant, making it easier for them to earn Cashback at their
        favourite stores. We would love to hear your feedback and your members’
        feedback and suggestions. Feel free to write to us any time at
        programs@saversapp.com
      </>
    ),
    date: 'January 24, 2025',
  },
  {
    id: 2,
    title: 'New Merchants Added',
    content: (
      <>
        More exciting news! In our ongoing effort to continuously enhance the
        Savers App experience, we’ve partnered with top US brands to bring even
        more shopping options to your customers. Some of the brands that have
        just been added include CVS, Bed Bath & Beyond, Temu, Lego, and Macy’s,
        to name a few.
      </>
    ),
    date: 'January 13, 2025',
  },
  {
    id: 3,
    title: 'New Cashback Features Launched',
    content: (
      <>
        Partners can now enjoy an enhanced cashback system that provides better
        rewards for both customers and merchants. Explore the latest features to
        boost your sales!
      </>
    ),
    date: 'October 10, 2024',
  },
  {
    id: 4,
    title: 'New US Brands Added to Our Merchants List',
    content: (
      <>
        Exciting news! We’ve partnered with top US brands to bring even more
        shopping options to your customers. Stay tuned for exclusive deals and
        promotions!
      </>
    ),
    date: 'October 8, 2024',
  },
  {
    id: 5,
    title: 'Shopping Season Promotions',
    content: (
      <>
        Get ready for the upcoming holiday shopping season with exclusive
        promotions for your customers. Boost sales with seasonal cashback
        offers!
      </>
    ),
    date: 'October 5, 2024',
  },
  {
    id: 6,
    title: 'Marketing Material Updates',
    content: (
      <>
        We’ve released new marketing materials to help you promote cashback
        offers and boost engagement. Download the latest assets from your admin
        panel now!
      </>
    ),
    date: 'October 1, 2024',
  },
];

// Define the News component
const News: React.FC = () => {
  return (
    <div className='py-4 md:py-6'>
      <h2 className='text-white bg-primary p-4 px-8 rounded-t-lg text-lg font-semibold'>
        Updates
      </h2>
      <div className='border border-gray-200 rounded-b-lg primary-shadow overflow-y-auto max-h-screen'>
        {newsData.map(item => (
          <div
            key={item.id}
            className='py-4 px-4 md:px-8 border-b last:border-b-0'
          >
            <h3 className='text-xl font-semibold'>{item.title}</h3>
            <p className='text-sm text-gray-600 mb-2'>{item.date}</p>
            <p className='text-gray-700 mb-4'>{item.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default News;
